import React, { Fragment, useCallback, useState } from 'react'
import toast from 'react-hot-toast'

import { TableOption, TableOptions } from 'Design/components/Table'
import ConfirmationModal from 'Design/components/ConfirmationModal'

import { useGetMyDataQuery } from 'Services/me'
import { useDeleteUserMutation, useDeactivateUserMutation, useActivateUserMutation } from './users.service'
import EditUser from './EditUser'
import Authorized from '../../../../components/Authorized'

const UserOptions = (props) => {
  const { id, is_active: isActive, is_verified: isVerified } = props

  const [showEditUserModal, setShowEditUserModal] = useState(false)
  const [showBotModal, setShowBotModal] = useState(false)
  const [modal, setModal] = useState(null)

  const { data: currentUser } = useGetMyDataQuery()
  const [deleteUser, deleteUserResult] = useDeleteUserMutation()
  const [deactivateUser, deactivateUserResult] = useDeactivateUserMutation()
  const [activateUser, activateUserResult] = useActivateUserMutation()

  const handleDeleteClick = useCallback(() => {
    const promise = deleteUser(id).unwrap()
    toast.promise(promise, {
      loading: 'Deleting user...',
      success: 'User deleted successfully.',
      error: 'Unable to delete user. Try again....'
    })
    promise.then(handleCloseModal)
  }, [id, deleteUser])

  const handleDeactivateClick = useCallback(() => {
    const promise = deactivateUser(id).unwrap()
    toast.promise(promise, {
      loading: 'Deactivating user...',
      success: 'User deactivated successfully.',
      error: 'Unable to deactivate user. Try again....'
    })
    promise.then(handleCloseModal)
  }, [id, deactivateUser])

  const handleActivateClick = useCallback(() => {
    const promise = activateUser(id).unwrap()
    toast.promise(promise, {
      loading: 'Activating user...',
      success: 'User activated successfully.',
      error: 'Unable to activate user. Try again....'
    })
    promise.then(handleCloseModal)
  }, [id, activateUser])

  const handleEditClick = useCallback(() => {
    setShowEditUserModal(true)
  }, [])

  const hideEditUserModal = useCallback(() => {
    setShowEditUserModal(false)
  }, [])

  const handleOpenModal = (data) => {
    setModal(data)
    setShowBotModal(true)
  }

  const handleCloseModal = () => {
    setShowBotModal(false)
  }

  const handleModalConfirmClick = () => {
    if (modal === 'Deactivate') {
      handleDeactivateClick()
    } else if (modal === 'Activate') {
      handleActivateClick()
    } else if (modal === 'Delete') {
      handleDeleteClick()
    }
  }

  const canDeactivateUser = isActive
  const canActivateUser = isVerified && !isActive
  const isApiProgress = deleteUserResult.isLoading || deactivateUserResult.isLoading || activateUserResult.isLoading

  return (
    <Fragment>
      <ConfirmationModal
        isOpen={showBotModal}
        title={`${modal} User`}
        description={
          `${modal}` === 'Deactivate'
            ? 'Are you sure to deactivate this user ?'
            : `${modal}` === 'Activate'
            ? 'Are you sure to activate this user ?'
            : 'Are you sure to delete this user ?'
        }
        onCloseButtonClick={() => handleCloseModal()}
        onConfirmButtonClick={handleModalConfirmClick}
        confirmButtonText='Yes'
        cancelButtonText='No'
        disableConfirmButton={isApiProgress}
      />
      {showEditUserModal && <EditUser user={props.user} hide={hideEditUserModal} />}
      <TableOptions disabled={currentUser.id === id}>
        <TableOption onClick={handleEditClick}>Edit</TableOption>
        <Authorized permissions={['user_write', 'user_delete']}>
          {canDeactivateUser && <TableOption onClick={() => handleOpenModal('Deactivate')}>Deactivate</TableOption>}
        </Authorized>
        <Authorized permissions={['user_write']}>
          {canActivateUser && <TableOption onClick={() => handleOpenModal('Activate')}>Activate</TableOption>}
        </Authorized>
        <Authorized permissions={['user_delete']}>
          <TableOption onClick={() => handleOpenModal('Delete')}>Delete</TableOption>
        </Authorized>
      </TableOptions>
    </Fragment>
  )
}

export default UserOptions
